import { createFileRoute, notFound } from '@tanstack/react-router';
import ProductList from '../../components/product-list/product-list';
import { getCollection } from '../../server/catalog.functions';
import { ProductCollectionSortKeys } from '../../types/types';
import { notFoundSeo, seo } from '../../utils/seo';
import { nullIfNotPrerendered } from '../../utils/static-data';

export const Route = createFileRoute('/_layout/_collections/$handle')({
  loader: async ({ params }) => {
    const collection = await getCollection({
      data: {
        handle: params.handle,
        first: 50,
        // newest first (like in the old project), so the new products ("új" tag) are on top
        sortKey: ProductCollectionSortKeys.Created,
        reverse: true
      }
    }).catch(nullIfNotPrerendered);

    if (!collection) {
      throw notFound();
    }

    return { collection };
  },
  head: ({ loaderData }) => {
    // the loader threw notFound()
    if (!loaderData) {
      return { meta: notFoundSeo() };
    }

    const { collection } = loaderData;

    return {
      meta: seo({
        // Shopify's SEO fields win if set, otherwise the description is used as the title (like in the old project)
        title:
          collection.seo.title || collection.description || collection.title,
        description: collection.seo.description || collection.description,
        image: collection.image?.url
      })
    };
  },
  component: CollectionRoute
});

function CollectionRoute() {
  const { collection } = Route.useLoaderData();

  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">{collection.title}</h1>
        <ProductList products={collection.products.nodes} />
      </div>
    </div>
  );
}
